import { Badge } from "@stocks/ui";
import { PURCHASE_ORDER_STATUS, type PurchaseOrderStatus } from "@stocks/shared";

import { ORDER_STATUS_LABELS } from "../lib/status";

export const OrderStatusBadge = ({ status }: { status: PurchaseOrderStatus }) => (
  <Badge
    variant={status === PURCHASE_ORDER_STATUS.OPEN ? "default" : "outline"}
  >
    {ORDER_STATUS_LABELS[status]}
  </Badge>
);
